import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "checked", "value"]

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppCheck',
  props: {
    id: {},
    modelValue: { type: [Boolean, Array] },
    value: {}
  },
  emits: [
	'update:modelValue',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const checked = computed(() => {
	if (props.modelValue instanceof Array) {
		return props.modelValue.includes(props.value);
	}

	return props.modelValue;
})

const inputUpdated = () => {
	if (props.modelValue instanceof Array) {
		const updated = [...props.modelValue];

		if (checked.value) {
			updated.splice(updated.indexOf(props.value), 1);
		} else {
			updated.push(props.value);
		}

		emit('update:modelValue', updated);

		return;
	}

	emit('update:modelValue', !props.modelValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "checkbox",
    id: __props.id,
    checked: checked.value,
    value: __props.value,
    onInput: inputUpdated
  }, null, 40, _hoisted_1))
}
}

})